import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import ShiftsScheduleView from '../../../components/hr/shifts/ShiftsScheduleView';
import ShiftChangeRequestsView from '../../../components/hr/shifts/ShiftChangeRequestsView';
import { Button, Segmented, Space, Card } from 'antd';
import { FileExcelOutlined, UnorderedListOutlined, ClockCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useResourcePermissions } from '../../../hooks/useResourcePermissions';
import { shiftsApi } from '../../../utils/api';

const Shifts = () => {
  const navigate = useNavigate();
  const { canAdd } = useResourcePermissions('shift');
  const [viewMode, setViewMode] = useState('schedule'); // 'schedule', 'requests'
  const [groupModalVisible, setGroupModalVisible] = useState(false);
  const [exporting, setExporting] = useState(false);
  const exportParamsRef = useRef(null);

  const handleGroupShiftAssignment = () => {
    setGroupModalVisible(true);
  };

  const handleExportExcel = async () => {
    if (!exportParamsRef.current) {
      message.warning('لطفاً ابتدا برنامه شیفت‌ها را بارگذاری کنید');
      return;
    }
    setExporting(true);
    try {
      await shiftsApi.exportExcel(exportParamsRef.current);
      message.success('خروجی اکسل در حال دانلود است');
    } catch (error) {
      console.error('Export shifts:', error);
      message.error(error?.message || 'خطا در خروجی اکسل');
    } finally {
      setExporting(false);
    }
  };

  const handleSummary = () => {
    message.info('خلاصه شیفت‌ها');
  };

  return (
    <MainLayout>
      <div className="" style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between flex-wrap gap-4 p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-purple-50 dark:bg-purple-900/20 flex items-center justify-center">
                <ClockCircleOutlined className="text-purple-600 dark:text-purple-400 text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">برنامه شیفت‌ها</h1>
                <p className="text-gray-500 dark:text-gray-400 text-sm m-0">مدیریت و برنامه‌ریزی شیفت‌های کارکنان</p>
              </div>
            </div>
            <Space size="middle" wrap>
              {viewMode === 'schedule' && canAdd ? (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleGroupShiftAssignment}
                  size="middle"
                  className="bg-green-600 hover:bg-green-700 border-0 shadow-md hover:shadow-lg transition-all"
                  style={{ fontFamily: 'CustomFont' }}
                >
                  اختصاص گروهی شیفت‌ها
                </Button>
              ) : null}
              <Button icon={<FileExcelOutlined />} onClick={handleExportExcel} loading={exporting} size="middle" style={{ fontFamily: 'CustomFont' }}>
                خروجی اکسل
              </Button>
            </Space>
          </div>

          <div className="p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            <div className="mb-4">
              <Segmented
                value={viewMode}
                onChange={setViewMode}
                options={[
                  {
                    label: 'برنامه',
                    value: 'schedule',
                    icon: <UnorderedListOutlined />,
                  },
                  {
                    label: 'درخواست‌های تغییر شیفت',
                    value: 'requests',
                    icon: <ClockCircleOutlined />,
                  },
                ]}
                size="large"
                style={{ fontFamily: 'CustomFont' }}
              />
            </div>

            <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4">
              {viewMode === 'schedule' && (
                <ShiftsScheduleView 
                  groupModalVisible={groupModalVisible}
                  onGroupModalClose={() => setGroupModalVisible(false)}
                  onExportParamsChange={(params) => { exportParamsRef.current = params; }}
                />
              )}
              {viewMode === 'requests' && <ShiftChangeRequestsView />}
            </div>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default Shifts;
